import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { LoadingIndicator } from '../../components';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import SocialWallPost from './socialwall-post.container';

class SingleSocialWallPost extends Component {

  constructor(props) {
    super(props);
    this.state = {

    };
  }

  componentWillMount() {
    if (this.props.match && this.props.match.params.socialWallPostId) {
      this.props.loadPost(this.props.match.params.socialWallPostId);
    }
  }

  componentWillReceiveProps({ match }) {
    if (match &&
        match.params.socialWallPostId &&
        match.params.socialWallPostId !== this.props.match.params.socialWallPostId) {
      this.props.loadPost(match.params.socialWallPostId);
    }
  }


  render() {
    if (!this.props.post) return null;

    if (this.props.loading) return <LoadingIndicator />;

    return (
      <Grid container>
        <Grid style={{ margin: 10, padding: 10 }} xs={12} md={12} lg={8}>
          <SocialWallPost
            post={this.props.post}
          />
        </Grid>
        <Grid xs={12} lg={4} />

      </Grid>
    );
  }
}

SingleSocialWallPost.propTypes = {
  match: PropTypes.any,
  loadPost: PropTypes.func,
  post: PropTypes.object,
  loading: PropTypes.bool,

};

SingleSocialWallPost.defaultProps = {
  match: null,
  loadPost: () => {},
  post: null,
  loading: false,
};

const styles = () => ({

});

export default withStyles(styles)(SingleSocialWallPost);



// WEBPACK FOOTER //
// ./src/app/main/socialwall/single-socialwall-post.js